<template>
    <rkm-area
        background-color="success"
        closed
        header-prefix-text="P"
        title="Plano"
        type="box"
    >
        <template v-if="!item.isAtendimentoSaudeBucal">
            <rkm-row>
                <rkm-col cols="12">
                    <strong>Informações adicionais sobre o plano de cuidado</strong><br><div v-html="formatDescricao(item.plano.descricao)"></div>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <BoxIntervencao :item="item" />
                </rkm-col>
            </rkm-row>
        </template>

        <rkm-row>
            <rkm-col cols="12">
                <BoxProcedimentoClinico :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxProcedimentoEmad :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="item.isAtendimentoSaudeBucal">
            <rkm-col cols="12">
                <BoxOdontograma :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxPrescricaoMedicamento :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    title="Solicitações de exames comuns"
                    type="fieldset"
                    no-margin-top
                    class="pt-0"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxExameSolicitado :item="item" />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxTriagemNeonatal :item="item" />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="12">
                            <BoxSolicitacaoExameComum :item="item" />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxSolicitacaoExameAltoCusto :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxTesteRapido :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxAtestado :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxDeclaracaoComparecimento :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxCartaMedica :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxOrientacao :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxEncaminhamento :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxCompartilhamentoCuidado :item="item" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxFeridas :item="item" />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import BoxAtestado from './components/atestado/Index'
import BoxCartaMedica from './components/carta-medica/Index'
import BoxCompartilhamentoCuidado from './components/compartilhamento-cuidado/Index'
import BoxFeridas from './components/feridas/Index'
import BoxDeclaracaoComparecimento from './components/declaracao-comparecimento/Index'
import BoxEncaminhamento from './components/encaminhamento/Index'
import BoxIntervencao from './components/intervencao/Index'
import BoxOdontograma from './components/odontograma/Index'
import BoxOrientacao from './components/orientacao/Index'
import BoxPrescricaoMedicamento from './components/prescricao-medicamento/Index'
import BoxProcedimentoClinico from './components/procedimento-clinico/Index'
import BoxProcedimentoEmad from './components/procedimento-emad/Index'
import BoxSolicitacaoExameComum from './components/solicitacao-exame-comum/Index'
import BoxExameSolicitado from './components/exame-solicitado/Index'
import BoxTriagemNeonatal from './components/triagem-neonatal/Index'
import BoxSolicitacaoExameAltoCusto from './components/solicitacao-exame-alto-custo/Index'
import BoxTesteRapido from './components/teste-rapido/Index'

export default {
    components: {
        BoxAtestado,
        BoxCartaMedica,
        BoxCompartilhamentoCuidado,
        BoxFeridas,
        BoxDeclaracaoComparecimento,
        BoxEncaminhamento,
        BoxIntervencao,
        BoxOdontograma,
        BoxOrientacao,
        BoxPrescricaoMedicamento,
        BoxProcedimentoClinico,
        BoxProcedimentoEmad,
        BoxSolicitacaoExameComum,
        BoxExameSolicitado,
        BoxTriagemNeonatal,
        BoxSolicitacaoExameAltoCusto,
        BoxTesteRapido,
    },
    props: {
        item: {type: Object, required: true},
    },
    methods: {
        formatDescricao(descricao) {

            if (descricao) {
                return descricao.replace(/\n/g, '<br>');
            }

            return null
        },
    }
}
</script>